<template>
  <div class="app">
      <div v-if="!session" class="auth">
        <AuthSupa />
      </div>
    <div  v-if="session" class="container">
      <div>
       <HeaderBar :user="user" />
      </div>
      <!-- <div>
          <ButtonPanel v-if="user" :user="user" />
        </div> -->
      <div class="side-by-side">
          <div class="greeting">
            
            <h4 class="title"><span class="blue">Hello</span></h4> <h4><span class="blue">{{ username }} </span></h4>
            <p class="subtitle">welcome to coloring AI, let's create drawings.</p>
            <div class="app-image">
                <img src="../assets/images/trex_party.jpg" alt="app-image" class="app-image-img">
            </div>
            <p class="subtitle">On the right is your AI prompt form <br>
             below is where the magic will be saved.</p>
            </div>

           <div class="prompt">
            <PromptForm @refresh-needed="refreshPrompts"/>
          </div>
          </div>
      
    <div class="prompts" id="prompts">
    <!-- <div class="status" v-if="loading">...Loading...</div> -->
        <div v-if="loading" class="loading-container">
          <div class="loading-spinner"></div>
          <p class="loading-text">Working, hold on...</p>
        </div>
    <div class="error" v-if="error">{{ error }}</div>
    <div v-if="!loading" class="tabs-panel">
      <button @click="selectTab('pages')" class="tab-button" :class="{ active: showPages }">My pages</button>
      <button @click="selectTab('explore')" class="tab-button" :class="{ active: showExplore }">Explore</button>
    </div>
    <ExploreTab v-if="showExplore"/>
    <template v-if="showPages">
    <div v-if="!loading" class="history-container">
        <div v-for="prompt in prompts" :key="prompt.id" class="prompt-item">
          <p class="prompt-description">{{ prompt.prompt }}</p>
          <img :src="prompt.image_url"  @click="openModal($event)" alt="prompt image" class="prompt-image"/>
          <button @click="goToColoring(prompt)" class="color-btn">🎨</button>
        </div>
      </div>
      <div v-if="!loading" class="names green"> <span><strong>Drawings</strong></span> </div>
     <div v-if="!loading" class="history-container">
          <div v-for="drawing in drawings" :key="drawing.id" class="prompt-item">
            <img
              :src="drawing.drawing_url"
              @click="openModal($event)"
              alt="drawing image"
              class="prompt-image"
            />
            <!-- <div class="button-row"> -->
            <button @click="goToColoring(drawing)" class="drawing-btn">🎨</button>
            <button @click="delDrawing(drawing.uuid)" class="drawing-btn">❌</button>
            <!-- </div> -->
          </div>
        </div>
    </template>

    <div>
      <div>
      <HowToPanel />
    </div>
      <ContactPanel />
    </div>
    </div>
    <div v-if="isModalOpen" class="modal-overlay" @click="closeModal">
      <div class="modal-content">
        <img :src="selectedImage || undefined" alt="Full size image" class="modal-image"/>
        <div class="modal-buttons">
          <button @click="printImage" class="print-btn">Print</button>
          <button @click="handleDelete" class="delete-btn">Delete</button>
          <button @click="closeModal" class="close-btn">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script lang="ts">

import { defineComponent, reactive, toRefs, onMounted, ref} from 'vue';
import { useRouter } from 'vue-router';
import HeaderBar  from '../components/HeaderBar.vue';
import AuthSupa  from '../components/AuthSupa.vue';    
import PromptForm from '../components/PromptForm.vue';
import ButtonPanel from '../components/ButtonPanel.vue';
import Prompt from '@/types/Prompt';
import Drawing from '@/types/Drawing';
import { useAuthStore } from '../stores/auth';
import { usePromptStore } from '../stores/prompts'
import { useDrawingsStore } from '@/stores/drawings';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';
import HowToPanel from '@/components/HowToPanel .vue';
import ContactPanel from '@/components/ContactPanel.vue';
import User from '@/types/User';
import { PrintPhoto } from '@/service/services';
import { useUserStore } from '@/stores/user';
import ExploreTab from '@/components/ExploreTab.vue';



export default defineComponent({
  name: 'App',
  components: { PromptForm, AuthSupa, HowToPanel, ContactPanel, HeaderBar, ExploreTab },
  setup() {
    const authStore = useAuthStore();
    const promptStore = usePromptStore();
    const drawingStore = useDrawingsStore();
    const userStore = useUserStore();
    const { session } = storeToRefs(authStore)
    const { user } = storeToRefs(userStore);
    const loading = ref<boolean>(true);
    const error = ref<string | null>(null);
    const prompts = ref<Prompt[]>([]);
    const drawings = ref<Drawing[]>([]);
    const isModalOpen = ref<boolean>(false);
    const selectedImage = ref<string | null>(null);
    const username = ref<string>('')
    const apiUrl = process.env.VUE_APP_DJANGO_BACKEND
    const loadingText = ref('Working hard...');
    const router = useRouter();
    const showPages = ref<boolean>(true)
    const showExplore = ref<boolean>(false)
    
    const fetchPrompts = async (accessToken: string) => {
        try {
          const response = await fetch(`${apiUrl}/api/prompts/`, {
            headers: { Authorization: `Bearer ${accessToken}` },
          });

          if (!response.ok) {
            const errorMessage = `Error: ${response.status} ${response.statusText}`;
            throw new Error(errorMessage);
          }
          prompts.value = await response.json();

        } catch (err) {
          error.value = err instanceof Error ? err.message : 'An error occurred';
        } finally {
          loading.value = false;
        }
      };

    const selectTab = (tab: 'pages' | 'explore') => {
        showPages.value = tab === 'pages';
        showExplore.value = tab === 'explore';
    };

    const refreshPrompts = async () => {
      await fetchPrompts(authStore.session?.access_token ?? '');
      };

    const fetchDrawings = async (accessToken: string) => {
        if (accessToken) {
            try {
                const response = await fetch(`${apiUrl}/api/drawings/`,{
                    headers: { Authorization: `Bearer ${accessToken}`},
                });

                if (!response.ok) {
                    const errorMessage = `Error: ${response.status} ${response.statusText}`;
                    throw new Error(errorMessage);
                }
                drawings.value = await response.json();

            }catch (err) {
                error.value = err instanceof Error ? err.message: "An error occured";
            }finally{
                loading.value=false;
            }
        }
    }

    const refreshDrawings = async () => {
      await fetchDrawings(authStore.session?.access_token ?? '');
      };

      onMounted(() => {
authStore.initializeAuthListener();
});


watch(
() => authStore.session,
async (newSession) => {
  if (newSession?.access_token) {
    try {
      loading.value = true;
      error.value = null;
      
      username.value = newSession.user?.email || '';
      const [promptsResult, fetchedUser, drawings] = await Promise.all([
        fetchPrompts(newSession.access_token),
        userStore.fetchUser(),
        fetchDrawings(newSession.access_token)

      ]);
      
      user.value = fetchedUser;  
      
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Failed to load data';
    } finally {
      loading.value = false;
    }
  }
},
{ immediate: true }
);

  const openModal = (event: MouseEvent) => {
      const image = event.target as HTMLImageElement;
      selectedImage.value = image.src;
      isModalOpen.value = true; 
    };


  const printImage = () => {
    if (selectedImage.value) {
      PrintPhoto(selectedImage.value)
    }
  }

    const closeModal = () => {
      isModalOpen.value = false;
    };


  const handleDelete = async () => {
  try {
    loading.value = true;
    error.value = null;

    if (!authStore.session?.access_token) {
      throw new Error('No access token found');
    }

    if (!selectedImage.value) {
      error.value = 'No image selected';
      return;
    }

    const url = selectedImage.value;

    if (url.includes('drawing_')) {
      const parts = url.split('_');
      const lastPart = parts[parts.length - 1];
      const drawingUuid = lastPart.split('?')[0];

      await delDrawing(drawingUuid);
    } else {
      const prompt = prompts.value.find((p) => p.image_url === url);
      if (!prompt) {
        error.value = 'Could not find prompt to delete';
        return;
      }
      await promptStore.deletePrompt(prompt.uuid, selectedImage.value);
    }

    await refreshPrompts();
    await refreshDrawings();

    isModalOpen.value = false;
    selectedImage.value = null;

  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Failed to delete image';
  } finally {
    loading.value = false;
  }
};



const delDrawing = async (drawingUuid:string) => {
  try{
    loading.value = true;
    error.value = null;

    if (!drawingUuid) {
      throw new Error("No drawing selected for deletion")
    }

    if (drawingUuid) {
    await drawingStore.deleteDrawing(authStore.session?.access_token ?? '', drawingUuid)}
    else {
      error.value = "No image found, try again"
      return;
    }
    
    await refreshDrawings();
      }catch (err) {
      error.value = err instanceof Error 
        ? err.message 
        : 'Failed to delete image';
    } finally {
      loading.value = false;
    }
  }

  const goToColoring = (data:Prompt | Drawing ) => {
    const image =
    'image_url' in data
    ? data.image_url
    : 'drawing_url' in data
    ? data.drawing_url
    : '';

    router.push({
      name:'ColoringPage',
      query: {image: image}
    })
  }

  const letters = loadingText.value.split('').map((letter, index) => ({
  char: letter,
  id: index
        }));

  return { prompts, loading, error, drawings,
            isModalOpen, selectedImage, session, username, letters, user, showExplore, showPages,
            openModal, closeModal, printImage, delDrawing, handleDelete, refreshPrompts, goToColoring, selectTab }

  },
});

</script>

<style scoped>

.app {
  width: 100%;
  min-height: 100vh; 
  display: flex;
  justify-content: center; 
  align-items: flex-start; 
  padding: 15px;
  box-sizing: border-box;
  z-index: 1; 
  background-size: cover; 
  background-position: center; 
  background-repeat: no-repeat;
}

button:hover {
  background-color: #f0f8f0;
  transform: translateY(-2px);
}

.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  gap: 15px;
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  box-sizing: border-box;
}

.side-by-side {
  display: flex;
  gap: 2rem; /* space between the two */
  align-items: flex-start; /* align items to the top */
  justify-content: space-between;
  flex-wrap: wrap; /* makes it responsive */
}

.greeting {
  flex: 1;
  min-width: 300px;
}

.prompt {
  display: flex;
  flex: 1;
  min-width: 300px;
}


.title {
    font-size: 2.5rem;
    font-weight: 800;
    line-height: 1.1;
    color: black;
    margin-bottom: 24px;
    text-align: center;
  }


  .subtitle {
    font-size: 1.1rem;
    color: #323232;
    margin-bottom: 1rem;
    text-align: center;
  }

.error {
  text-align: center;
  margin: 20px 0;
  color: red;
  padding: 10px;
  background-color: #ffebee;
  border-radius: 4px;
}

.greeting {
  text-align: center;
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 2rem 0;
  }
  
  .loading-spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #e2e8f0;
    border-top: 4px solid #42a8b4;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .loading-text {
    color: #42a8b4;
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
    background: linear-gradient(90deg, #42a8b4, #6dd496, #42a8b4);
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: shimmer 2s linear infinite;
  }

.app-image-img {
  max-width: 75%;
  height: auto;
  border-radius: 8px;
  margin: 10px;
}

.subtab {
  display: flex;
  align-items: center;       
  justify-content: center;   
  text-align: center;         
  margin-top: 20px;
}

.status {
  margin: 15px 0;
  text-align: center;
  font-size: 14px;
  background: linear-gradient(90deg, #ccc, #F8ED8C, #ccc);
  background-size: 200% auto;
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  animation: shine 1s linear infinite;
}

@keyframes shine {
  to { background-position: 200% center; }
}

.prompt, .prompts {
  flex: 1;
}

h2 {
  margin-top: 0;
  font-size: 18px;
}

h4 {
  font-size: 16px;
  margin: 8px 0;
}

h5 {
  margin: 5px 0;
  font-size: 14px;
  font-weight: normal;
}

p {
  font-size: 12px;
  margin-bottom: 8px;
  line-height: 1.4;
}


.tabs-panel {
  display: flex;
  justify-content: flex-start;
  gap: 2px;
}

.tab-button {
  border: none;
  padding: 8px 22px;
  font-weight: 600;
  color: #8a8a8a;
  background-color: #ececec;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
}

.tab-button.active {
  background-color: white;
  color: #157e15;
}

.history-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); 
  gap: 12px; 
  padding: 0;
  max-width: 100%; 
  box-sizing: border-box;
  margin-top: 15px;
  margin-bottom: 40px;
  border-bottom: 3px solid transparent
}

.prompt-item {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  box-sizing: border-box; 
  transition: all 0.3s ease;
  background-color: #fafafa;
}

.prompt-item:hover {
  transform: translateY(-2px);
  /* box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-color: #157e15; */
}

.prompt-description {
  margin-bottom: 8px;
  text-align: left;
}

.prompt-image {
  flex-grow: 1; 
  object-fit: contain;
  max-height: 100%;
  width: 100%;
  border-radius: 4px;
  transition: transform 0.3s ease;
  cursor: pointer;
}


.prompt-image:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-color: #157e15;
}

.color-btn {
  margin-top: 10px;
  width: 90%;
  border: none;
  text-align: center;
  align-content: center;
  align-self: center;
  background-color: white;
}

.drawing-btn {
  margin-top: 3px;
  width: 100%;
  border: none;
  text-align: center;
  align-content: center;
  align-self: center;
  background-color: white;
}

.names {
  padding:10px 20px;
  background-color: #fafaf9;
  width: 15%;
  border-radius: 10px 10px 0 0;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

.modal-content {
  position: relative;
  max-width: 90vw; 
  max-height: 90vh; 
  background-color: white;
  padding: 15px;
  display: flex;
  flex-direction: column; 
  justify-content: center; 
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

.modal-image {
  max-width: 100%; 
  max-height: calc(90vh - 100px);
  object-fit: contain;
  margin-bottom: 15px;
  border-radius: 8px;
}

.modal-buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
  margin-top: 10px;
}

.modal-buttons button {
  padding: 12px 16px;
  font-size: 14px;
  cursor: pointer;
  border: none;
  border-radius: 6px;
  flex: 1;
  margin: 0;
  font-weight: 600;
  transition: all 0.3s ease;
}

.modal-buttons .print-btn {
  background-color: #6dd496;
  color: #2d5a2d;
}

.modal-buttons .print-btn:hover {
  background-color: #5bc482;
}

.modal-buttons .delete-btn {
  background-color: #de6767;
  color: white;
}

.modal-buttons .delete-btn:hover {
  background-color: #d45454;
}

.modal-buttons .close-btn {
  background-color: #e7ea80;
  color: #5a5d2d;
}

.modal-buttons .close-btn:hover {
  background-color: #e0e36d;
}

/* Tablet Styles (768px and up) */
@media (min-width: 768px) {
  .app {
    padding: 20px;
  }

  .container {
    max-width: 600px;
    padding: 25px;
    gap: 20px;
  }

  button {
    padding: 10px 16px;
    font-size: 14px;
    margin: 0 8px;
  }

  h2 {
    font-size: 22px;
  }

  h4 {
    font-size: 18px;
  }

  h5 {
    font-size: 16px;
  }

  p {
    font-size: 14px;
  }

  .history-container {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .prompt-item {
    padding: 15px;
  }

  .modal-content {
    max-width: 80vw;
    padding: 20px;
  }

  .modal-buttons button {
    padding: 14px 20px;
    font-size: 15px;
  }
}

/* Desktop Styles (1024px and up) */
@media (min-width: 1024px) {
  .app {
    padding: 30px;
  }

  .container {
    max-width: 900px;
    padding: 30px;
    gap: 25px;
  }

  button {
    padding: 12px 20px;
    font-size: 16px;
    margin: 0 10px;
  }

  .green {
  color:#8EB486;
}

  .greet {
    font-size: 20px;
  }

  h2 {
    font-size: 26px;
  }

  h4 {
    font-size: 20px;
  }

  h5 {
    font-size: 18px;
  }

  p {
    font-size: 15px;
  }

  .history-container {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-top: 20px;
  }

  /* .prompt-item {
    padding: 18px;
  } */

  .modal-content {
    max-width: 70vw;
    padding: 25px;
  }

  .modal-buttons {
    gap: 12px;
  }

  .modal-buttons button {
    padding: 16px 24px;
    font-size: 16px;
  }
}

/* Large Desktop Styles (1440px and up) */
@media (min-width: 1440px) {
  .container {
    max-width: 1200px;
  }

  .history-container {
    grid-template-columns: repeat(5, 1fr);
  }
}

</style>